import { SLA_CONSTANTS } from './constants'
import * as rest from '../../services'
export const getTicketSLA = () => {
  return (dispatch) => {
    dispatch({ type: SLA_CONSTANTS.GET_SLAS_REQUEST })
    return new rest.SLAService()
      .makeGetRequest({
        sla_type: 'TICKET_SLA',
        page_size: 1000,
      })
      .then((response) => {
        const data = {
          ticket_slas: response.results,
        }
        dispatch({ type: SLA_CONSTANTS.GET_SLAS_SUCCESS, response: data })
      })
      .catch((errors) => {
        let data = {
          ticket_slas: errors,
        }
        dispatch({ type: SLA_CONSTANTS.GET_SLAS_FAILURE, errors, data })
      })
  }
}
